<script lang="ts">
	import type {
		Command as CommandPrimitive,
		Dialog as DialogPrimitive,
		WithoutChildrenOrChild,
	} from 'bits-ui'
	import type { Snippet } from 'svelte'
	import { cn } from 'tailwind-variants'

	import * as Dialog from '#lib/components/ui/dialog/index.js'

	import Command from './command.svelte'

	let {
		open = $bindable(false),
		ref = $bindable(null),
		value = $bindable(''),
		title = 'Command Palette',
		description = 'Search for a command to run...',
		showCloseButton = false,
		portalProps,
		children,
		class: className,
		...restProps
	}: WithoutChildrenOrChild<DialogPrimitive.RootProps> &
		WithoutChildrenOrChild<CommandPrimitive.RootProps> & {
			portalProps?: DialogPrimitive.PortalProps
			children: Snippet
			title?: string
			description?: string
			showCloseButton?: boolean
			class?: string
		} = $props()
</script>

<Dialog.Root bind:open {...restProps}>
	<Dialog.Header class="sr-only">
		<Dialog.Title>{title}</Dialog.Title>
		<Dialog.Description>{description}</Dialog.Description>
	</Dialog.Header>
	<Dialog.Content
		class={cn('top-1/3 translate-y-0 overflow-hidden rounded-xl! p-0', className)}
		{portalProps}
		{showCloseButton}
	>
		<Command {...restProps} {children} bind:value bind:ref />
	</Dialog.Content>
</Dialog.Root>
